import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';
import { PathConstant } from 'src/app/shared/constant/path.constant';
import { environment } from '../../../environments/environment';
import { ISellerAll } from '../../shared/model/seller.model';
// import { environment } from 'src/environments/environment';

const MOCK_TOKEN: any = environment?.accessToken;
@Injectable({
  providedIn: 'root',
})
export class TokenService {
  stockRouterPass: boolean = false;

  constructor(private cookieService: CookieService) {
    // if (!this.cookieService?.get('accessToken')) {
    //   this.cookieService?.set('accessToken', MOCK_TOKEN);
    // }
  }

  getPathNavigateToLoginPage() {
    if (this.getDataToken().authentication) {
      sessionStorage.removeItem('landingSubMenuList');
      return PathConstant.SALE_PORTAL_PAGE;
    } else {
      // return PathConstant.SALE_PORTAL_PAGE_OLD_PAGE;
      return
    }
  }

  getDataToken():any {
    if(this.cookieService?.get('accessToken')){
      const token: ISellerAll = jwtDecode(this.cookieService?.get('accessToken'))
      token.channel = 'MyChannel';
      return token;
    }
    
  }

  calculateTokenToExpire(thresholdMinutes = 10) {
    const accessToken = this.getDataToken();
    const currentTime = Math.floor(Date.now() / 1000);
    const timeUntilExpiration = accessToken.exp - currentTime;
    return timeUntilExpiration >= 0 && timeUntilExpiration <= thresholdMinutes * 60;
  }
}
